export default {
    methods: {
        mobileValidation(value) {
            const ALLOWED_CHARS_REGEXP =  /^$|(\+98|0098|98|0)?9\d{9}$/;
            if (value.match(ALLOWED_CHARS_REGEXP)) {
                return true;
            }
            return false;
        },
    }
}